import styled from 'styled-components';

export const Container = styled.header`
  display: flex;
  justify-content: space-around;
  align-items: center;

  // margin-bottom: 30px;
  padding: 12.5px 0;
  background: #0B4682;
  color: #fff;

  @media only screen and (max-width: 768px) {
    margin-bottom: 0;
    padding-left: 20px;
    padding-right: 20px;
    justify-content: space-between;
  }
`;

export const Logo = styled.img`
  width: 100%;
  :hover {
    opacity: .9;
  }
  
  @media only screen and (max-width: 768px) {
    width: 50%;
  }
`;